import { useState } from 'react'

import { storage } from '@/lib/storage'

const KEY = 'pos.sell.cart_width'
export const CART_MIN = 340
export const PRODUCTS_MIN = 420

/** The cart's width on the Sell page (large screens), kept per device; null = the default split. */
export const useCartWidth = () => {
  const [width, setWidth] = useState<number | null>(() => storage.read<number | null>(KEY, null))
  const commit = (next: number | null) => {
    setWidth(next)
    storage.write(KEY, next)
  }
  return { width, setWidth, commit }
}

/** Grid columns for a set cart width; the products side never drops below its minimum when the window narrows. */
export const sellColumns = (width: number) => `minmax(0,1fr) clamp(${CART_MIN}px, ${width}px, calc(100% - ${PRODUCTS_MIN}px))`
